import React from "react";

import Modal from "components/Models/index";

import restoreIcon from "assets/images/fileImage/restoreIcon.svg";

import "./restoreModal.scss";

// Preload the icon to prevent loading delay when the modal is opened
const preloadImg = new Image();
preloadImg.src = restoreIcon;

const RestoreModal = ({ handleCancel, handleSave, content }) => {
  return (
    <Modal
      submitBtnText="Restore"
      handleSave={handleSave}
      handleCancel={handleCancel}
      showCross={false}
    >
      <div className="restoreContainer">
        <img src={restoreIcon} alt="" />
        <p>{content}</p>
      </div>
    </Modal>
  );
};

export default RestoreModal;
